var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKey = function SvgKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    viewBox: "0 0 24 25",
    d: "m21.041 9.34 1.126-1.127a.565.565 0 0 0 0-.799l-1.992-1.992.176-.176a1.4 1.4 0 0 0 .132-1.866 1.36 1.36 0 0 0-2.015-.098l-8.946 8.945a5.196 5.196 0 1 0 1.924 1.924l4.32-4.318 2.067 2.069c.22.22.579.22.799 0l1.126-1.126a.565.565 0 0 0 0-.8L17.69 7.91l.561-.562 1.992 1.992c.22.22.578.22.798 0ZM7.363 19.162a2.47 2.47 0 1 1-.836-4.867 2.47 2.47 0 0 1 .837 4.867Z"
  })));
};
export default SvgKey;